import {
    GET_REPORT,
    GET_OVERLAY,
    SET_REPORT_LOADING,
    REMOVE_REPORT_LOADING,
    SET_REPORT_SKELETON
} from "../types";

const initialState = {
    loading: false, // Initit loading state
    reportData: {}
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_REPORT_LOADING:
            return {
                ...state,
                loading: true
            };
        case REMOVE_REPORT_LOADING:
            return {
                ...state,
                loading: false
            };
        case GET_REPORT:
            return {
                ...state,
                reportData: { ...payload }
            };
        case GET_OVERLAY:
            return {
                ...state,
                overlayData: { ...payload }
            };
        case SET_REPORT_SKELETON:
            return {
                ...state,
                reportSkeleton: { ...payload }
            };
        default:
            return state;
    }
}